import React, { useState } from 'react'

import { Edit as EditIcon, Home as HomeIcon, Print as PrintIcon } from '@material-ui/icons'

import { useAsyncPrint } from 'src/components/ToPrint/useAsyncPrint'
import { ShipmentLabel } from 'src/modules/supply_chain/components/parcel/ShipmentLabel'
import { PackingSlip } from 'src/modules/supply_chain/components/parcel/PackingSlip'
import { ParcelShipmentDialog } from 'src/modules/supply_chain/components/parcel/ShipmentDialog'
import {
  AddressField,
  DateTimeField,
  StatusField,
  RelatedLinkedField,
  ValueField,
} from 'src/components/Table'
import { DetailComponent } from './base'

interface ObjInfo {
  data: any
  isLoading: boolean
}

interface DetailTableProps {
  obj: ObjInfo
  refresh?: () => void
}

export const ParcelShipmentDetailTable = (props: DetailTableProps) => {
  const { obj, refresh } = props
  const [updateOpen, setUpdateOpen] = useState(false)
  const { print: asyncPrint, renderPrintComponent: renderAsyncPrintComponent } = useAsyncPrint()

  return (
    <>
      {renderAsyncPrintComponent()}
      {updateOpen && (
        <ParcelShipmentDialog
          open={updateOpen}
          shipment={obj.data}
          update
          handleClose={() => {
            setUpdateOpen(false)
          }}
          onSave={refresh}
        />
      )}
      <DetailComponent
        obj={obj}
        Icon={HomeIcon}
        menuItems={[
          {
            Icon: EditIcon,
            actions: [{ title: 'Edit Parcel Shipment', onClick: () => setUpdateOpen(true) }],
          },
          {
            Icon: PrintIcon,
            actions: [
              {
                title: 'Print Shipment Placard',
                onClick: () =>
                  asyncPrint((props) => <ShipmentLabel {...props} shipment={obj.data} />),
              },
              {
                title: 'Print Packing Slip',
                onClick: () =>
                  asyncPrint((props) => <PackingSlip {...props} guid={obj.data.guid || ''} />),
              },
              {
                title: 'Print All',
                onClick: () =>
                  asyncPrint((props) => (
                    <>
                      <ShipmentLabel shipment={obj.data} />
                      <PackingSlip {...props} guid={obj.data.guid || ''} />
                    </>
                  )),
              },
            ],
          },
        ]}
        fields={[
          { id: 'guid', label: 'SquID', renderer: ValueField },
          { id: 'trackingNumber', label: 'Tracking Number', renderer: ValueField },
          { id: 'client', label: 'Client', renderer: RelatedLinkedField(ValueField, 'name') },
          { id: 'order', label: 'Order', renderer: RelatedLinkedField(ValueField, 'name') },
          {
            id: 'facility',
            label: 'Facility',
            renderer: RelatedLinkedField(ValueField, 'name'),
          },
          { id: 'carrier', label: 'Carrier', renderer: RelatedLinkedField(ValueField, 'name') },
          { id: 'address', label: 'Address', renderer: AddressField },
          { id: 'status', label: 'Status', renderer: StatusField },
          { id: 'internalNotes', label: 'Internal Notes', renderer: ValueField },
          { id: 'shippedOn', label: 'Shipped On', ordering: 'shipped_on', renderer: DateTimeField },
        ]}
      />
    </>
  )
}
